import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";

import routingStartsWith from "../../../../common/helpers/routingStartsWith";

import routing from "../../../routing";
import logout from "../../../store/user/actions/logout";
import { useUser } from "../../../store/user/selectors";

import NavLeft from "./NavLeft";
import NavRight from "./NavRight";
import NavMobile from "./NavMobile";

import {
    StyledNav,
    NavSpring,
} from "./styles";

const Nav = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const user = useUser();
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    useEffect(() => {
        window.addEventListener("resize", resize);
        return () => {
            window.removeEventListener("resize", resize);
        }
    }, []);
    const resize = () => {
        if (window.innerWidth > 768 && mobileMenuOpen) {
            setMobileMenuOpen(false);
        }
    };
    const handleLogout = () => {
        dispatch(logout());
        history.push("/" + routing.choir);
    }

    const navigate = () => {
        setMobileMenuOpen(old => !old)
    };

    const changeLanguage = (language: string) => {
        window.renderPageWithLanguage(language);
    };

    const { pathname } = history.location;
    let isPathDashboard = routingStartsWith(pathname, routing.choir + "/" + routing.dashboard) ||
        routingStartsWith(pathname, routing.choir + "/" + routing.choir);
    let isSignup = routingStartsWith(pathname, routing.choir + "/" + routing.signup);
    let isModeration =
        routingStartsWith(pathname, `${routing.choir}/${routing.moderation}`);
    let isAccount = routingStartsWith(pathname, `${routing.choir}/${routing.account}`);
    let isLogin = routingStartsWith(pathname, `${routing.choir}/${routing.login}`);

    let props = {
        loggedIn: user.loggedIn,
        pathname,
        admin: user.permission >= 2,
        profiled: user.profiled,
        user,
        isPathDashboard,
        isSignup,
        isModeration,
        isAccount,
        isLogin,
    };
    let auth = {
        logout: handleLogout,
    };
    return (
        <StyledNav>
            <NavSpring>
                <NavLeft {...props} />
                <NavRight
                    {...props}
                    {...auth}
                    mobileMenuOpen={mobileMenuOpen}
                    changeLanguage={changeLanguage}
                    handleOpenMobileMenu={navigate}
                />
                <NavMobile {...props} {...auth} mobileMenuOpen={mobileMenuOpen} navigate={navigate} />
            </NavSpring>
        </StyledNav>
    );
}

export default Nav;
